import styled from "styled-components";

const SelectTeacherContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
    margin-top: 16px;

    @media only screen and (max-width: 850px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

const SelectTeacher = styled.div`
    display: flex;
    flex-direction: column;

    align-items: flex-start;
    margin-right: 16px;
    width: 50%;
    height: auto;

    > div {
        > div {
            > div {
                > input {
                    border-radius: 4px;
                }
            }
        }
    }

    @media only screen and (max-width: 850px) {
        width: 100%;
    }
`;

const SelectTeacherAutocompleteStyles = {
    marginBottom: "0",
    width: "100%",
};

export default {
    SelectTeacherContainer,
    SelectTeacher,
    SelectTeacherAutocompleteStyles,
};
